module.exports = __webpack_public_path__ + "img/head-blur-img.4c2ef264.png";